// ================================
// CUSTOMER LOGIN
// ================================
import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function CustomerLogin() {
  const [searchParams]        = useSearchParams();
  const [mid, setMid]         = useState(searchParams.get('mid') || '');
  const [pin, setPin]         = useState('');
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(false);
  const { loginCustomer }     = useAuth();
  const navigate              = useNavigate();

  async function handleLogin(e) {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await loginCustomer(mid, pin);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Invalid MID or PIN');
    } finally { setLoading(false); }
  }

  return (
    <div className="app-shell" style={{ padding:'28px' }}>
      <button className="back-btn" onClick={() => navigate('/')}>← Back</button>
      <h2 style={{ fontFamily:'Bebas Neue, sans-serif', fontSize:30, letterSpacing:2, marginBottom:4 }}>Welcome Back</h2>
      <p style={{ fontSize:13, color:'#3a5a8a', marginBottom:28 }}>Enter your M.I.D. and PIN to continue.</p>
      <form onSubmit={handleLogin}>
        <div className="field">
          <label>Member ID (M.I.D.)</label>
          <input type="text" placeholder="12345" maxLength={5} value={mid} onChange={e => setMid(e.target.value)} required />
        </div>
        <div className="field">
          <label>PIN</label>
          <input type="password" placeholder="••••" maxLength={4} value={pin} onChange={e => setPin(e.target.value)} required />
        </div>
        {error && <p style={{ color:'#c0101a', fontSize:13, marginBottom:12 }}>{error}</p>}
        <div style={{ marginTop:24 }}>
          <button className="btn-primary" type="submit" disabled={loading}>
            {loading ? 'Signing In...' : 'Sign In'}
          </button>
          <p style={{ textAlign:'center', fontSize:12, color:'#3a5a8a', marginTop:14 }}>
            Not a member? <span style={{ color:'#1e6bff', cursor:'pointer' }} onClick={() => navigate('/signup')}>Request access</span>
          </p>
          <p style={{ textAlign:'center', fontSize:12, color:'#3a5a8a', marginTop:8 }}>
            First time with a new card? <span style={{ color:'#1e6bff', cursor:'pointer' }} onClick={() => navigate('/activate')}>Activate it</span>
          </p>
        </div>
      </form>
    </div>
  );
}
